var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.developmentHistory},[_c('div',{class:_vm.$style.historyTitle},[_vm._v(" "+_vm._s(_vm.info.title)+" ")]),_c('div',{class:_vm.$style.historyImgBox},[_c('img',{attrs:{"src":_vm.info.coverMobile,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }